import React, { Component } from 'react';
import moment from 'moment';

import CheckingParkingModel from '../components/CheckingParkingModel';
import CheckingParkingTable from '../components/CheckingParkingTable';
import AutoZoneDetectionsModel from '../components/AutoZoneDetectionsModel';
import AutoZoneDetectionsTable from '../components/AutoZoneDetectionsTable';
import AutoDetectionsTableExpander from '../components/AutoDetectionsTableExpander';
import UserModel from './UserModel';

import { Table, Row, Col, Modal, Popconfirm, Typography, message } from 'antd';

import { dateRenderer, dateSorter } from './Helpers';

class AutoDetectionsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    statusDetail: {
      showed: false,
      data: null
    },
    zoneDetectionDetail: {
      showed: false,
      data: null
    }
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  onClickImg(base64data) {
    var newTab = window.open('', '_blank', "menubar=no,status=no,titlebar=no,location=no,toolbar=no,scrollbars=yes,resizable=yes,top=50,left=500,width=800,height=600");
    newTab.document.body.innerHTML = '<img src="' + base64data + '">';
  }

  expandedRowRender(record) {
    return (
      <div>
        <AutoDetectionsTableExpander images={record.Images} />
      </div>
    );
  }

  onShowStatusDetail(record) {
    let statusDetail = this.state.statusDetail;
    statusDetail.showed = true;
    this.setState({
      statusDetail
    });

    statusDetail.parkinglocation = record.ParkingLocationID;
    statusDetail.licenceplate = record.Plate.slice(-4);
    statusDetail.timestamp = record.Timestamp;
    statusDetail.plate = record.Plate;

    CheckingParkingModel.getAll(
      statusDetail.parkinglocation,
      statusDetail.licenceplate,
      statusDetail.timestamp)
      .then(data => {
        statusDetail.data = data
        this.setState({
          statusDetail
        });
      })
      .catch(err => {
        message.warning('Pakovací oprávnění se nepodařilo načíst!');
        statusDetail.data = [];
        this.setState({
          statusDetail
        });
      });
  }

  onShowZoneDetectionDetail(record) {
    let zoneDetectionDetail = this.state.zoneDetectionDetail;
    zoneDetectionDetail.showed = true;
    this.setState({
      zoneDetectionDetail
    });

    zoneDetectionDetail.parkinglocation = record.ParkingLocationID;
    zoneDetectionDetail.timestamp = record.Timestamp;

    AutoZoneDetectionsModel.getLastByParkinglocationAndTimestamp(
      zoneDetectionDetail.parkinglocation,
      zoneDetectionDetail.timestamp)
      .then(data => {
        zoneDetectionDetail.data = data
        this.setState({
          zoneDetectionDetail
        });
      });
  }

  render() {
    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'ParkingLocationName',
      key: 'ParkingLocationName',
    }, {
      title: 'Reg. značka',
      dataIndex: 'Plate',
      key: 'Plate'
    }, {
      title: 'ReadID',
      dataIndex: 'ReadID',
      key: 'ReadID'
    }, {
      title: 'Čas detekce',
      dataIndex: 'Timestamp',
      key: 'Timestamp',
      width: 230,
      render: (text, record) => (
        <span>{text ? moment(text).format('LLLL') : null}</span>
      ),
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        return (a.Timestamp < b.Timestamp) ? -1 : ((a.Timestamp > b.Timestamp) ? 1 : 0);
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 150,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'PARKDETECT_DETECTIONS_WRITE'])) {
          return (
            <div>
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow(record.id)
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }} />
        <Modal
          width={920}
          title={this.state.statusDetail.plate
            ? 'Parkovací opravnění pro RZ '
            + this.state.statusDetail.plate
            + ' : '
            + this.state.statusDetail.licenceplate
            : 'Parkovací opravnění pro RZ '}
          visible={this.state.statusDetail.showed}
          onCancel={() => {
            let statusDetail = {
              showed: false,
              data: null
            };
            this.setState({ statusDetail });
          }}
          footer={<p></p>} >
          <CheckingParkingTable
            data={!this.state.statusDetail.data ? [] : this.state.statusDetail.data}
            loading={!this.state.statusDetail.data ? true : false}
            rowKey="plate"
          />
        </Modal>
        <Modal
          width={920}
          title="Přehledové snímky"
          visible={this.state.zoneDetectionDetail.showed}
          onCancel={() => {
            let zoneDetectionDetail = {
              showed: false,
              data: null
            };
            this.setState({ zoneDetectionDetail });
          }}
          footer={<p></p>} >
          <AutoZoneDetectionsTable
            data={!this.state.zoneDetectionDetail.data ? [] : this.state.zoneDetectionDetail.data}
            loading={!this.state.zoneDetectionDetail.data ? true : false}
            rowKey="plate"
          />
        </Modal>
      </div>
    );
  }
}

export default AutoDetectionsTable;


// WEBPACK FOOTER //
// ./src/components/AutoDetectionsTable.js